import { SET_RECORDS } from "./mutation-types";

const mutations = {
  [SET_RECORDS](state, data) {
    state.recordsInfo = data;
  },
};

export default mutations;
